<template>
    <div
        v-b-popover.hover.top="{
            content: `${progressPercent}%`,
            disabled: hidePopover,
        }"
        class="l-progress"
    >
        <div class="progress" :class="`progress-${size}`">
            <div
                v-show="progressPercent"
                class="progress-bar"
                :class="progressBarClass"
                role="progressbar"
                :style="`width: ${progressPercent}%;`"
                data-test-id="l-progress-bar"
            ></div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        progressPercent: {
            type: [Number, String],
            default: 0,
        },
        progressBarClass: {
            type: String,
            default: "progress-bar-success",
        },
        size: {
            type: String,
            default: "sm",
        },
        hidePopover: {
            type: Boolean,
            default: false,
        },
    },
    // A `data` property is needed so that this file is taken into account by jest's code coverage
    // (cf. https://github.com/vuejs/vue-jest/issues/32)
    //
    data() {
        return {};
    },
};
</script>

<style scoped>
.l-progress .progress {
    margin: 0;
}
</style>
